import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ContactService {
  private data = [
    {item: 1, name:"Business User"},
    {item: 2, name:"Decision Maker"},
    {item: 3, name:"Economic Buyer"},
    {item: 4, name:"Economic Decision Maker"},
    {item: 5, name:"Evaluator"},
    {item: 6, name:"Executive Sponsor"},
    {item: 7, name:"Influencer"},
    {item: 8, name:"Technical Buyer"},
  ]

  getFunctionsData(){
    return this.data;
  }
}
